import React from 'react'
import { useModel } from 'umi'
import { Drawer, Pagination } from 'antd'

import Table from './components/Table'
import Query from './components/Query'
import ExportBtn from './components/ExportBtn'

import styles from './index.less'

// eslint-disable-next-line no-magic-numbers
const pageSizeOptions = [10, 20, 30, 50, 100]

const Content = () => {
    return (
        <div className={styles.container}>
            <div className={styles.sticky}>
                <Query />
                <div className={styles.actions}>
                    <ExportBtn type="goods" />
                    <ExportBtn type="order" />
                </div>
            </div>
            <Table />
        </div>
    )
}

const Footer = () => {
    const { pagination, total, setPaginationWithFetch } = useModel('useBreakPriceDrawer')

    return (
        <Pagination
            {...pagination}
            className={styles.pagination}
            total={total}
            pageSizeOptions={pageSizeOptions}
            showQuickJumper={false}
            showSizeChanger={true}
            showTotal={_ => `共${_}条记录`}
            onChange={(current, pageSize) => {
                setPaginationWithFetch({
                    current,
                    pageSize
                })
            }}
        />
    )
}

const BreakPriceDrawer = ({ visible, onCancel }) => {
    return (
        <Drawer
            visible={visible}
            onClose={onCancel}
            title="分销商破价明细"
            destroyOnClose
            placement="right"
            width={1008}
            bodyStyle={{ padding: '0 24px' }}
            footerStyle={{ padding: '10px 24px' }}
            footer={<Footer />}>
            <Content />
        </Drawer>
    )
}

export default BreakPriceDrawer
